import React, { useEffect, useState } from 'react'
import { INITIAL_VALUES, toFormValues } from './form'
import { useErrorHandling } from 'context/errorHandling'
import { SuccessDialog } from 'components/Shared/Dialogs'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { fetchUserGroup, fetchUserGroupMembers, updateUserGroup } from 'services/UserGroupsService'
import UserGroupsForm from 'components/UserGroups/UserGroupsForm/UserGroupsForm'
import { Loader } from 'components/Shared/Loader'
import { USER_GROUP_EDIT } from 'context/auth'

export function UserGroupsEditForm (props) {
  const userGroupId = props.match.params.id

  const [successDialogOpen, setSuccessDialogOpen] = useState(false)
  const [initialValues, setInitialValues] = useState(INITIAL_VALUES)
  const [initialMembers, setInitialMembers] = useState([])
  const [loading, setLoading] = useState(false)

  const { t } = useTranslation()
  const history = useHistory()
  const { handleError } = useErrorHandling()

  useEffect(() => {
      fetchUserGroup(userGroupId)
        .then(toFormValues)
        .then(setInitialValues)
        .catch(handleError)
    }, [userGroupId, handleError]
  )
  useEffect(() => {
      fetchUserGroupMembers(userGroupId)
        .then(setInitialMembers)
        .catch(handleError)
    }, [userGroupId, handleError]
  )

  const handleSubmit = (updatedGroup, handleGroupMembersChange) => {
    setLoading(true)
    Promise.all([
      updateUserGroup(userGroupId, updatedGroup),
      handleGroupMembersChange(userGroupId)
    ])
      .then(() => setSuccessDialogOpen(true))
      .catch(handleError)
      .then(() => setLoading(false))
  }

  const handleSuccessDialogClose = () => {
    setSuccessDialogOpen(false)
    history.push('/user-groups')
  }

  return (
    <>
      {loading && <Loader/>}
      <SuccessDialog
        content="userGroups.form.edit.onSuccessMessage"
        open={successDialogOpen}
        onClose={handleSuccessDialogClose}
      />
      <UserGroupsForm
        onSubmit={handleSubmit}
        initialValues={initialValues}
        initialMembers={initialMembers}
        title={t('userGroups.form.edit.title')}
        requiredPrivileges={[USER_GROUP_EDIT]}
      />
    </>
  )
}
